import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { mapErrorMessage } from "../utils";
import { setErrorMessage } from "./errors";
import api from "../api";

const initialState = {
  methods: {
    creditCards: [],
    accounts: [],
  },
};

const paymentSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setPaymentMethod(state, action) {
      state.paymentMethod = action.payload;
    },
    setPaymentMethodsAllowed(state, action) {
      state.methods = {
        creditCards: action.payload.creditCards,
        accounts: action.payload.accounts,
      };
    },
  },
});

const { actions, reducer } = paymentSlice;

export const {
  setPaymentMethod,
  setPaymentMethodsAllowed,
  setPaymentMethodsDeny,
} = actions;

export const fetchPaymentMethods = () => async (dispatch, getState) => {
  try {
    const { auth, user } = getState();
    const { data } = await api.get(
      "/seguros/metodo-pago/ch/PDS",
      {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
    );
    if (Object.keys(data).length === 0) {
      dispatch(setErrorMessage(mapErrorMessage("paymentMethodsError")));
      dispatch(push("/error"));
    } else {
      dispatch(setPaymentMethodsAllowed(data));
    }
  } catch (error) {
    dispatch(setErrorMessage(mapErrorMessage("systemError")));
    dispatch(push("/error"));
  }
};

export default reducer;
